/*
 *
 * ContactsPage14326 const
 *
 */

export const CONTACTS_DX_GRID = 'ContactsDxGrid';
